import { licenzaPdfUrl } from './licenzaPdf'

let cachedSha256: string | null = null

export async function computeLicensePdfSha256(): Promise<string> {
  if (cachedSha256) return cachedSha256
  const response = await fetch(licenzaPdfUrl)
  const buffer = await response.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  cachedSha256 = Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
  return cachedSha256
}
